import api from "./api";
import log from "loglevel";

// actions
const actions = {
  async getHybridViewerReaderLaunchUrl(context, params) {
    try {
      return await api.getHybridViewerReaderLaunchUrl(params);
    } catch (error) {
      log.error("getHybridViewerReaderLaunchUrl error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async postSecretWord(context, params) {
    try {
      const res = await api.postSecretWord(params);
      return res.status;
    } catch (error) {
      log.error("postSecretWord error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  },
  async postRatingAgreements(context, params) {
    try {
      const res = await api.postRatingAgreements(params);
      return res.status;
    } catch (error) {
      log.error("postRatingAgreements error:", error);
      context.commit("common/setError", error, { root: true });
      return error.status;
    }
  }
};

export default {
  namespaced: true,
  actions
};
